module.exports = __webpack_public_path__ + "img/logo.f510e37f.png";